import { Injectable } from '@angular/core';
import { Location } from '@angular/common';
import { PlRouter } from '@shared/services/pl-router.service';

export const TOKEN_KEY: string = 'pl3-token';
export const URL_PARAM_TOKEN: string = 'token';

@Injectable({
  providedIn: 'root',
})
export class CredentialsService {
  private _token: string | null = null;

  constructor(
    private location: Location,
    private plRouter: PlRouter,
  ) {
    let tokenFromUrl: string | null = null;
    const searchParams: URLSearchParams = new URLSearchParams(this.location.path());
    if (searchParams.has(URL_PARAM_TOKEN)) {
      tokenFromUrl = searchParams.get(URL_PARAM_TOKEN);
      this.setToken(tokenFromUrl);
      this.plRouter.removeQueryParamFromUrl(URL_PARAM_TOKEN);
    }

    const savedToken: string | null =
      tokenFromUrl || sessionStorage.getItem(TOKEN_KEY) || localStorage.getItem(TOKEN_KEY);
    if (savedToken) {
      this._token = savedToken;
    }
  }

  public isAuthenticated(): boolean {
    return !!this.token;
  }

  public get token(): string | null {
    return this._token;
  }

  public setToken(token: string | null): void {
    this._token = token || null;

    if (token) {
      localStorage.setItem(TOKEN_KEY, token);
    } else {
      sessionStorage.removeItem(TOKEN_KEY);
      localStorage.removeItem(TOKEN_KEY);
    }
  }
}
